import {combine, TimelinePipe} from "@pnp/core";
import {Picker} from "../Picker";
import {MicrosoftLogin} from "../../MicrosoftLogin";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";

const debug = initDebugger('MSALAuthenticate');

export function MSALAuthenticate(microsoftLogin: MicrosoftLogin): TimelinePipe<Picker> {
    return (instance: Picker) => {

        instance.on.authenticate(async function (this: Picker, command, result) {
            debug('on.authenticate', command, result);
            if (typeof result === "undefined") {
                try {
                    // Se MicrosoftLogin.ts og https://learn.microsoft.com/en-us/entra/identity-platform/scopes-oidc#the-default-scope
                    // for info om .default scopet.
                    // Merk at OneDriveFilvelgerGui.sharepointUrl() vil alltid ha blitt kalt på et tidligere tidspunkt
                    // (før Picker initialiseres) og consent dialog vil da har blitt vist.
                    // Dersom kallet til microsoftLogin.hentTokenMedScope(..) under forepør andre tilganger enn
                    // OneDriveFilvelgerGui.sharepointUrl() gjorde vil ingen ny consent-dialog bli vist og returnert
                    // token vil ikke innehold eventuelle ytterligere tilganger.
                    // Dersom det skulle være behov for ytterligere tilganger kan fremvisning av consent-dialog for
                    // disse tvinges ved å angi 'prompt' attributtet til PublicClientApplication.loginPopup()
                    let accessToken = await microsoftLogin.hentTokenMedScope([`${combine(command.resource, ".default")}`]);
                    if (accessToken) result = {result: 'token', token: accessToken}

                } catch (e) {
                    debug('on.authenticate error', e)
                    if (!MicrosoftLogin.erUserCanceledError(e) && !MicrosoftLogin.erConsentRequiredError(e))
                        this.error(e);
                    this.abort(); //fører til at picker.activate returnerer med null
                }
            }
            debug('on.authenticate returnerer', command, result);
            return [command, result];
        });

        return instance;
    };
}
